import { fetchAPI } from "../../../config/api";

export async function fetchSplitsLeaderboard(leaderboardPath, division, year) {
  const params = new URLSearchParams({
    division,
    start_year: String(year),
    end_year: String(year),
  });
  return fetchAPI(`${leaderboardPath}?${params}`);
}
